import { useLiveQuery } from 'dexie-react-hooks'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Button, Footer, Header } from '../../components'
import moment from 'moment'
import { db } from '../../lib/db'
import './DeliveryOrdersStyle.scss'

const DeliveryOrders = () => {
  const { t } = useTranslation('planified')
  const history = useHistory()
  const [search, setSearch] = useState('')

  const orderDeliveries = useLiveQuery(async () => {
    const today = moment().format('YYYY-MM-DD')
    const ols = await db.orderDeliveries.toArray()
    return ols.filter((ol) => ol.deliveryDate === today)
  }, [])

  const filteredDeliveries = orderDeliveries?.filter((ol) =>
    ol.orderDeliveryNumber.toLowerCase().includes(search.toLowerCase())
  )

  const selectDeliveryOrder = async (order) => {
    const MAT = order.materials.filter((e) => e.family === 'MATERIAL')
    const RUB = order.materials.filter((e) => e.family === 'RUBBLE')

    const allDeliveries = await db.deliveries.toArray()
    const lastDelivery = allDeliveries.sort((a, b) => b.createdAt?.localeCompare(a.createdAt))[0]

    try {
      // Ajout dans la base Dexie
      await db.offlineOrders.add({
        site: order.site,
        siteId: order.siteId,
        customer: order.clientName,
        customerId: order.clientId,
        constructionNb: order.constructionSiteCode,
        constructionId: order.constructionSiteId,
        address: order.deliverySiteAddress,
        city: order.deliverySiteCity,
        destinationSite: order.destinationSite,
        forwarder: order.forwardingAgent ? order.forwardingAgent : '',
        externalReference: order.externalReference,
        plate: lastDelivery?.truckLicencePlate || '',
        process: 'validate',
        outMaterials: MAT,
        inMaterials: RUB,
        orderDeliveryId: order.id,
      })
      // Redirection
      history.push('/orders/new')
    } catch (error) {
      console.error('Error fetching command data or processing order:', error)
    }
  }

  return (
    <div>
      <Header title="Ordres de livraison" />
      <div className="history">
        <div className="history-content">
          {/* Zone de filtre */}
          <div className="history-filter">
            <p>{t('filter')}</p>
            <input
              placeholder={t('search')}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Contenu principal */}
          <div className="history-item-content">
            <table>
              <thead>
                <tr>
                  <th>{t('orderDeliveryNumber')}</th>
                  <th>{t('clientName')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredDeliveries && filteredDeliveries.length > 0 ? (
                  filteredDeliveries.map((ol) => (
                    <tr key={ol.id}>
                      <td>
                        <div>{ol.orderDeliveryNumber}</div>
                        <div>
                          {moment(ol.deliveryDate).format('DD/MM/YYYY')}{' '}
                          {ol.deliveryTimeStart
                            ? ol.deliveryTimeStart.substring(0, 5).replace(':', 'h')
                            : ''}
                          {ol.deliveryTimeEnd && ol.deliveryTimeStart !== ol.deliveryTimeEnd
                            ? ` – ${ol.deliveryTimeEnd.substring(0, 5).replace(':', 'h')}`
                            : ''}
                        </div>
                      </td>
                      <td>{ol.clientName}</td>
                      <td>
                        <button onClick={() => selectDeliveryOrder(ol)}>{t('select')}</button>
                      </td>
                    </tr>
                  ))
                ) : orderDeliveries && orderDeliveries.length > 0 ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center' }}>
                      {t('noMatchingDeliveries')}{' '}
                      {/* Message lorsqu'aucun résultat n'est trouvé dans la recherche */}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center' }}>
                      {t('noPlanifiedDeliveries')}{' '}
                      {/* Message lorsqu'il n'y a aucun ordre de livraison planifié */}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer>
        <Button
          text={t('back')}
          appearance="secondary"
          type="outline"
          width="210px"
          onClick={() => history.push('/endPending')}
        />
      </Footer>
    </div>
  )
}

export default DeliveryOrders
